import React from 'react';
import { Checkbox } from '@mantine/core';
import { TOUCH_TARGET } from '@/hooks/use.responsive';

type Props = {
    checked: boolean;
    indeterminate?: boolean;
    label: string;
    onToggle: (extend: boolean) => void;
};

const stop = (event: React.SyntheticEvent) => event.stopPropagation();

/* La casella disegnata è di 20px, ma il target di tocco deve essere di 44:
 * l'etichetta collegata copre tutta l'area e inoltra il clic alla casella,
 * così l'area grande è davvero premibile e non solo un contorno vuoto. */
const ListCheck: React.FC<Props> = ({ checked, indeterminate, label, onToggle }) => {
    const id = React.useId();

    return (
        <label
            htmlFor={id}
            onClick={stop}
            onKeyDown={stop}
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: `${TOUCH_TARGET}px`,
                height: `${TOUCH_TARGET}px`,
                cursor: 'pointer',
            }}
        >
            <Checkbox
                id={id}
                checked={checked}
                indeterminate={indeterminate}
                aria-label={label}
                size="sm"
                onChange={(event) => onToggle((event.nativeEvent as MouseEvent | KeyboardEvent).shiftKey === true)}
            />
        </label>
    );
};

export default ListCheck;
